import { getBorderRadius } from '$lib/global/helper/border-radius';
import { getShadow } from '$lib/global/helper/shadow';

import type { BrandBorderRadius, BrandShadow, Theme } from '$lib/types/Theme';

export interface ResolvedMediaAnswerStyling {
    borderRadiusClass: string;
    shadowClass: string | undefined;
    textBgColor: string | undefined;
}

interface Params {
    theme: Theme;
    bgColor?: string;
}

export const resolveMediaAnswerStyling = ({
    theme,
    bgColor,
}: Params): ResolvedMediaAnswerStyling => ({
    borderRadiusClass: getBorderRadius(
        'choiceItem',
        theme.borderRadius as BrandBorderRadius | undefined,
    ),
    shadowClass: theme.shadow ? getShadow('choiceItem', theme.shadow as BrandShadow) : undefined,
    textBgColor: bgColor && bgColor !== 'transparent' ? bgColor : theme.secondary ?? undefined,
});
